module.exports = __webpack_public_path__ + "media/images/country_flags/zw-5cd06487b865bf1fbad0d8b32c54d843.png";